import BoldIcon from "@redotech/redo-icons/bold-01.svg";
import ItalicIcon from "@redotech/redo-icons/italic-01_filled.svg";
import PencilLineIcon from "@redotech/redo-icons/pencil-line_filled.svg";
import StrikethroughIcon from "@redotech/redo-icons/strikethrough-01_filled.svg";
import UnderlineIcon from "@redotech/redo-icons/underline-01_filled.svg";
import ZapIcon from "@redotech/redo-icons/zap.svg";
import { AlignToolbarButton } from "@redotech/redo-web/components/plate-ui/align-toolbar-button";
import { ClearFormattingToolbarButton } from "@redotech/redo-web/components/plate-ui/clear-formatting-toolbar-button";
import { ColorToolbarButton } from "@redotech/redo-web/components/plate-ui/color-toolbar-button";
import { EmojiToolbarButton } from "@redotech/redo-web/components/plate-ui/emoji-toolbar-button";
import { FontFamilyToolbarButton } from "@redotech/redo-web/components/plate-ui/font-family-toolbar-button";
import { FontSizeToolbarButton } from "@redotech/redo-web/components/plate-ui/font-size-toolbar-button";
import { LinkToolbarButton } from "@redotech/redo-web/components/plate-ui/link-toolbar-button";
import { ListToolbarButton } from "@redotech/redo-web/components/plate-ui/list-toolbar-button";
import { MarkToolbarButton } from "@redotech/redo-web/components/plate-ui/mark-toolbar-button";
import {
  FileToolbarButton,
  ImageToolbarButton,
} from "@redotech/redo-web/components/plate-ui/media-toolbar-buttons";
import {
  ToolbarButton,
  ToolbarGroup,
} from "@redotech/redo-web/components/plate-ui/toolbar";
import { ToolbarWithOverflow } from "@redotech/redo-web/components/plate-ui/toolbar-overflow";
import { cn } from "@redotech/redo-web/tailwind-utils";
import { KEYS } from "platejs";
import { memo } from "react";
import { AiMenuToolbarButton } from "./ai-menu-toolbar-button";

export interface EmailToolbarProps {
  className?: string;
  hasSignature?: boolean;
  isGeneratingAiResponse?: boolean;
  isPolishingMessage?: boolean;
  onFileSelect?: (files: File[]) => void;
  onGenerateAiResponse?: () => void;
  onImageSelect?: (file: File) => void;
  onMacroClick?: () => void;
  onPolishMessage?: () => void;
  onToggleSignature?: () => void;
  showSignature?: boolean;
}

export const EmailToolbar = memo(function EmailToolbar({
  className,
  hasSignature,
  isGeneratingAiResponse,
  isPolishingMessage,
  onFileSelect,
  onGenerateAiResponse,
  onImageSelect,
  onMacroClick,
  onPolishMessage,
  onToggleSignature,
  showSignature,
}: EmailToolbarProps) {
  return (
    <ToolbarWithOverflow className={cn("border-border px-1 py-1", className)}>
      <ToolbarGroup>
        <AiMenuToolbarButton
          isGeneratingAiResponse={isGeneratingAiResponse}
          isPolishingMessage={isPolishingMessage}
          onGenerateAiResponse={onGenerateAiResponse}
          onPolishMessage={onPolishMessage}
        />
        <ToolbarButton Icon={ZapIcon} onClick={onMacroClick} tooltip="Macros" />
        {hasSignature && (
          <ToolbarButton
            Icon={PencilLineIcon}
            onClick={onToggleSignature}
            pressed={showSignature}
            tooltip={showSignature ? "Hide signature" : "Show signature"}
          />
        )}
      </ToolbarGroup>

      <FontFamilyToolbarButton />
      <FontSizeToolbarButton />

      <ToolbarGroup>
        <MarkToolbarButton
          Icon={BoldIcon}
          nodeType={KEYS.bold}
          tooltip="Bold (⌘+B)"
        />
        <MarkToolbarButton
          Icon={ItalicIcon}
          nodeType={KEYS.italic}
          tooltip="Italic (⌘+I)"
        />
        <MarkToolbarButton
          Icon={UnderlineIcon}
          nodeType={KEYS.underline}
          tooltip="Underline (⌘+U)"
        />
        <MarkToolbarButton
          Icon={StrikethroughIcon}
          nodeType={KEYS.strikethrough}
          tooltip="Strikethrough"
        />
      </ToolbarGroup>

      <ColorToolbarButton />
      <AlignToolbarButton />

      <ListToolbarButton />
      <LinkToolbarButton />
      <EmojiToolbarButton />
      <ImageToolbarButton onImageSelect={onImageSelect} />
      <FileToolbarButton onFileSelect={onFileSelect} />

      <ClearFormattingToolbarButton />
    </ToolbarWithOverflow>
  );
});
